import {CKEditor} from "@ckeditor/ckeditor5-react";

import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Link,
    Image,
    ImageBlock,
    ImageUpload,
    ImageToolbar,
    ImageResizeEditing,
    ImageResizeHandles,
    ImageResizeButtons,
    ImageStyle,
    ImageTextAlternative,
    Undo
} from "ckeditor5";


import "ckeditor5/ckeditor5.css";
import {CustomUploadAdapterPlugin} from "../../hooks/CustomUploadAdapterPlugin";

export const Editor = ({getEditorData, handleEditor, setFocusEditor, cardId}) => {
    const editorData =
        typeof getEditorData === "function"
            ? getEditorData()
            : getEditorData || "";

    return (
        <CKEditor
            editor={ClassicEditor}
            data={editorData}
            config={{
                licenseKey: "GPL",
                plugins: [
                    Essentials,
                    Paragraph,
                    Heading,
                    Bold,
                    Italic,
                    Link,

                    Image,
                    ImageBlock,
                    ImageUpload,
                    ImageToolbar,
                    ImageResizeEditing,
                    ImageResizeHandles,
                    ImageResizeButtons,
                    ImageStyle,
                    ImageTextAlternative,

                    Undo
                ],
                customUploadAdapter: {
                    cardId,
                },
                extraPlugins: [CustomUploadAdapterPlugin],
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "imageUpload",
                    "|",
                    "undo",
                    "redo"
                ],
                image: {
                    resizeUnit: "%",

                    toolbar: [
                        "imageTextAlternative",
                        "|",
                        "imageStyle:block",
                        "imageStyle:inline",
                        "imageStyle:side",
                        "|",
                        "resizeImage"
                    ],

                    resizeOptions: [
                        {
                            name: "resizeImage:original",
                            label: "Original",
                            value: null
                        },
                        {
                            name: "resizeImage:25",
                            label: "25%",
                            value: "25"
                        },
                        {
                            name: "resizeImage:50",
                            label: "50%",
                            value: "50"
                        },
                        {
                            name: "resizeImage:75",
                            label: "75%",
                            value: "75"
                        }
                    ]
                }
            }}
            onChange={(event, editor) => handleEditor(event, editor)}
            onFocus={() => setFocusEditor(true)}
            onBlur={() => setFocusEditor(false)}
        />
    );
};
